import type {VariantProps} from 'class-variance-authority'
import {Link, type LinkProps} from 'react-router-dom'
import {Button, type buttonVariants} from '@/components/ui/button'

type ButtonLinkProps = LinkProps &
    VariantProps<typeof buttonVariants> & {
        disabled?: boolean
    }

export const ButtonLink = ({className, variant, size, shape, children, disabled, ...linkProps}: ButtonLinkProps) => (
    <Button
        className={className}
        disabled={disabled}
        nativeButton={false}
        render={
            disabled ? (
                <a />
            ) : (
                <Link
                    {...linkProps}
                    onClick={event => {
                        if (disabled) {
                            event.preventDefault()
                            event.stopPropagation()
                        } else {
                            linkProps.onClick?.(event)
                        }
                    }}
                />
            )
        }
        shape={shape}
        size={size}
        variant={variant}
    >
        {children}
    </Button>
)
